export * from "modules/AppointmentDetails/components/VehicleTyres/components/TyreTable/components/ReplacementOfferModal/components/TyreExternalOfferTable";
export * from "modules/AppointmentDetails/components/VehicleTyres/components/TyreTable/components/ReplacementOfferModal/components/TyreOfferTable";
